<template>
  <div class="btn-group flex items-center w-full gap-2">
    <slot />
  </div>
</template>

<script setup>

</script>
